import { get } from "lodash";
import { all, call, put, takeEvery } from "redux-saga/effects";

import { pushWithUTM } from "helpers/sagas";
import { ApiManager } from "services/api";
import { RequestAction } from "store/entities/actions";
import { TICKET, TicketActions } from "store/entities/tickets/actions";
import { ISendTicketRatingPayload } from "store/entities/tickets/interfaces";
import { IActionWithPayload } from "store/helper";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* sendTicketRating(action: IActionWithPayload<string, ISendTicketRatingPayload>) {
  const { id: ticketId, token, rating, comment, submitted } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.ticketApi.sendRating, ticketId, { token, rating, comment });
  if (response.result) {
    yield put(TicketActions.sendRatingSuccess());
    if (submitted) {
      yield put(pushWithUTM("/rate/thank-you"));
    }
  } else {
    yield put(TicketActions.sendRatingFailure());
    if (get(response, "error.error.message") === "ticket already rated") {
      yield put(pushWithUTM("/rate/already-rated"));
    } else {
      yield put(pushWithUTM("/rate/expired"));
    }
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* ticketRatingSagas() {
  yield all([takeEvery(TICKET.SEND_RATING[RequestAction.REQUEST], sendTicketRating)]);
}
